
export const PRINTING_TYPES = {
    direct_to_garment: "Apparel Printing",
    dye_sublimation: "Dye Sublimation",
    embroidery: "Embroidery",
    other: "Other",
};

const DEFAULT_LOCATION_POSITIONS = [
    {
        label: "Front",
        value: "front",
    },
    {
        label: "Back",
        value: "back",
    },
];

const LOCATIONS_WITH_SLEEVES = [
    ...DEFAULT_LOCATION_POSITIONS,
    {
        label: "Left Sleeve",
        value: "left_sleeve",
    },
    {
        label: "Right Sleeve",
        value: "right_sleeve",
    },
];

const LOCATIONS_WITH_SIDES = [
    ...DEFAULT_LOCATION_POSITIONS,
    {
        label: "Left Side",
        value: "left_side",
    },
    {
        label: "Right Side",
        value: "right_side",
    },
];

export const PRINTING_LOCATIONS = {
    t_shirt: LOCATIONS_WITH_SLEEVES,
    hoodie: LOCATIONS_WITH_SLEEVES,
    polo_shirt: LOCATIONS_WITH_SLEEVES,
    raglan_long_sleeve: LOCATIONS_WITH_SLEEVES,
    womens_leggings: DEFAULT_LOCATION_POSITIONS,
    tank_top: DEFAULT_LOCATION_POSITIONS,
    baby_onesie: DEFAULT_LOCATION_POSITIONS,
    tote_bag: DEFAULT_LOCATION_POSITIONS,
    sweat_pants: LOCATIONS_WITH_SIDES,
    shorts: LOCATIONS_WITH_SIDES,
};